module.exports = __webpack_public_path__ + "yogaImg2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yogaImg2.jpg
// module id = 302
// module chunks = 0